import { makeStyles } from '@material-ui/core';
import logoUrl from '../../assets/fnmz-logo-horizontal.svg';

/*
 * The corporate lockup ships in FN green, which is also the sidebar background.
 * Rather than keeping a second recoloured copy of the asset around, the SVG is
 * used as an alpha mask and painted in the sidebar's own foreground colour, so
 * it stays correct in both the light and the dark theme.
 *
 * The lockup is very wide (~10.4:1), so it is sized to the open drawer width
 * rather than to a fixed height.
 */
const useStyles = makeStyles(theme => ({
  logo: {
    width: 190,
    height: 20,
    backgroundColor: theme.palette.navigation.selectedColor,
    maskImage: `url(${logoUrl})`,
    maskRepeat: 'no-repeat',
    maskPosition: 'left center',
    maskSize: 'contain',
    WebkitMaskImage: `url(${logoUrl})`,
    WebkitMaskRepeat: 'no-repeat',
    WebkitMaskPosition: 'left center',
    WebkitMaskSize: 'contain',
  },
}));

export const LogoFull = () => {
  const classes = useStyles();

  return (
    <div
      className={classes.logo}
      role="img"
      aria-label="Fressnapf | maxi zoo"
    />
  );
};
